// Public language options only: preserve the legacy IDs/ISO/order without mutating JSON.
export function normaliseLanguageCatalogue(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return [];
  const entries = Object.entries(data);
  if (!entries.length || entries.some(([, value]) => !value || typeof value !== 'object' ||
    [null, undefined, ''].includes(value.llangue_id ?? value.object_id) ||
    ['pt', 'es', 'en'].some(locale => typeof value[locale] !== 'string' || !value[locale].trim()))) return [];
  if (new Set(entries.map(([, value]) => String(value.llangue_id ?? value.object_id))).size !== entries.length) return [];
  const main = ([iso]) => ['es', 'en', 'pt'].includes(iso);
  return [...entries.filter(main), ...entries.filter(entry => !main(entry))]
    .map(([isoCode, value]) => ({ ...value, isoCode }));
}

export function createLanguageCatalogueReader({ fetchImpl = (...args) => fetch(...args), timeoutMs = 5000 } = {}) {
  let pending = null;
  return function readLanguages() {
    if (pending) return pending;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    const operation = (async () => {
      try {
        const response = await fetchImpl('/data/languages.json', { signal: controller.signal, credentials: 'omit' });
        return response.ok ? normaliseLanguageCatalogue(await response.json()) : [];
      } catch {
        return [];
      } finally {
        clearTimeout(timer);
      }
    })().finally(() => { if (pending === operation) pending = null; });
    pending = operation;
    return operation;
  };
}

export const readLanguageCatalogue = createLanguageCatalogueReader();
